module.exports = __webpack_public_path__ + "img/mile1m-m@2.23ea0d6c.jpg";